import { ThresholdLineStyle, LineStyle, ThresholdFeature, ThresholdLine } from './models';
import { EffectiveDefinition } from '../../models';
import { isConstantCalculation } from '../../transforms/calculations/ConstantCalculation';
import { Features } from '../../models';

export function getThresholdFeature(features: Features): ThresholdFeature | undefined {
  return features.threshold;
}

export function getDefaultLineForThreshold(feature?: ThresholdFeature): ThresholdLine | undefined {
  return feature?.thresholds?.[0]?.lines?.[0];
}

export function getLineStyleForDefaultThresholdLine(definition: EffectiveDefinition): ThresholdLineStyle | undefined {
  return getDefaultLineForThreshold(definition.features.threshold)?.style;
}

export function getStylePropsForDefaultThresholdLine(definition: EffectiveDefinition): React.CSSProperties | undefined {
  const lineStyle = getLineStyleForDefaultThresholdLine(definition);
  return lineStyle?.lineStyle === LineStyle.DASHED ? DASHED_LINESTYLE : undefined;
}

const DASHED_LINESTYLE: React.CSSProperties = {
  strokeDasharray: '1 5',
  strokeLinecap: 'round',
};

export const shouldRenderFirstThresholdLine = (definition: EffectiveDefinition): boolean => {
  return shouldRenderFirstThresholdLineFromFeature(getThresholdFeature(definition.features));
};

export const shouldRenderFirstThresholdLineFromFeature = (feature?: ThresholdFeature): boolean => {
  const line = getDefaultLineForThreshold(feature);
  if (!line) {
    return false;
  }
  const hidden = line?.style?.hidden;
  return hidden ? false : true;
};

export const getStaticTargetValue = (definition: EffectiveDefinition): number | undefined => {
  if (!isDefaultLineStaticRefLine(definition)) {
    return undefined;
  }
  const line = getDefaultLineForThreshold(definition.features.threshold);
  if (line === undefined) {
    return undefined;
  }
  const measureCalculation = definition.schema[line.measure.column].calculation;
  if (!isConstantCalculation(measureCalculation)) {
    return undefined;
  }
  return measureCalculation.value;
};

export const isDefaultLineStaticRefLine = (definition: EffectiveDefinition): boolean => {
  const line = getDefaultLineForThreshold(definition.features.threshold);
  if (!line || line.timestamp || !definition.schema[line.measure.column]) {
    return false;
  }

  return isConstantCalculation(definition.schema[line.measure.column].calculation);
};
